import type { AgentApiIamsShow } from '@/types/serializers';
import { useQuery } from '@tanstack/react-query';
import qs from 'qs';

export default function useFetchIam() {
  const query = qs.stringify('', { arrayFormat: 'brackets' });
  return useQuery({
    queryKey: ['iam', query, 1, ''],
    queryFn: async () => {
      const response = await fetch(`/agent/api/iam.json?${query}`);
      const data: AgentApiIamsShow = await response.json();

      return data;
    },
  });
}
